import {mergeTo} from '#core/utils/config-utils.js';
import {SpriteMapStorage} from '#core/utils/spritemap-storage/index.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {SportsContent} from '../sports-content.js';

import {sportsPagesFactory} from './sport-page.factory.js';
import {getMatchSportsDefaultPagePriority} from './utils.js';

import PALETTE_SCHEMA from './sport-page.palette-schema.yaml';
import SCHEMA from './sport-page.schema.yaml';

class SportPagesFeature extends AbstractVisualFeature {
    get name() {
        return 'Sport Page';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        const {matchSportLandingPage, matchSportsDefaultPagePriority} = this.config;
        const sportsDefaultPagePriority = getMatchSportsDefaultPagePriority(
            matchSportsDefaultPagePriority,
            matchSportLandingPage.default,
            matchSportLandingPage.sports
        );

        return mergeTo(sportsPagesFactory(PALETTE), {
            SportDefaultPage: {
                sports: sportsDefaultPagePriority,
            },
            SportIcons: {
                defaultIcon: 'default',
                ...SpriteMapStorage.sportIdToSpritesMapping,
            },
        });
    }
}

new SportPagesFeature(SportsContent);
